<template>
	<div class="single-page-wrap">
		<cube-scroll ref="scroll" class="cube-scroll">
			<div>
				<div class="advwrap"></div>
				<div class="header">
					<i class="cubeic-back" @click="back"></i>
					订单信息
				</div>
				<div class="order-panel">
					<div class="order-record">
						<div class="park-name">{{parkrec.parkName}}</div>
						<div class="plate">
							<span>{{parkrec.plateno || '未获取'}}</span>
							<div class="check-pic" @click="showImg">查看照片</div>
						</div>
						<div class="in-time">
							<span>{{parkrec.inTime || ''}}入场</span>
						</div>
						<!--//v-show="checkedCouponOptions.length > 0 && Object.keys(orderSnList).length > 0-->
						<div class="discount-panel"
							 v-show="checkedCouponOptions.length > 0 && Object.keys(orderSnList).length > 0">
							<div class="div_check" @click="isChecked">
								<div class="div_left" :class="{'check':checked}">
									<img src="@/common/img/check.png" alt/>
								</div>
								<div class="div_right">是否使用优惠券</div>
							</div>
							<article class="weui-article" v-show="checked">
								<section>
									<div class="weui-cell weui-cell_active weui-cell_access weui-cell_select weui-cell_select-after">
										<div class="weui-cell__hd" style="color: #0d0d0d"><label
												class="weui-label">优惠券</label></div>
										<div class="weui-cell__bd" style="color: #6d6d6d"
											 v-if="checkedCouponOptions.length <= 0">无
										</div>
										<div class="weui-cell__bd" v-else @click="handleCouponOption">
											{{checkedCoupon}}
										</div>
									</div>
								</section>
							</article>
						</div>
					</div>

					<div class="order-info">
						<div class="price-wrap">
							需缴费
							<div class="price">¥{{parseFloat(orderInfo.totalPrice).toFixed(2)}}</div>
						</div>
						<!-- <div class="order-item">
						  停车费
						  <div class="right-order">¥{{orderInfo.totalPrice || '0.00'}}</div>
						</div>
						<div class="order-item">
						  已缴费/折扣
						  <div class="right-order">¥{{orderInfo.discount || '0.00'}}</div>
						</div>-->
						<div class="order-item" v-show="checked">
							优惠
							<div class="right-order">¥{{couponFee || '0.00'}}</div>
						</div>
						<div class="order-item">
							入场时间
							<div class="right-order">{{parkrec.inTime || '未获取到'}}</div>
						</div>
						<div class="order-item">
							出场时间
							<div class="right-order">{{parkrec.outTime || '未获取到'}}</div>
						</div>
						<div class="order-item">
							停车时长
							<div class="right-order">{{parkrec.parkHours || '0分钟'}}</div>
						</div>
					</div>
				</div>

				<div class="btn-pay" @click="pay">支付</div>

				<div v-if="isCardPay == 1" class="btn-pay btn-member" @click="memberPay">会员卡支付</div>
				<div class="hint-wrapper">
					<div class="hint-panel">
						<div class="hint-item">关注公众号，停车费支付更便捷</div>
						<div class="hint-bottom">
							<img src="@/common/img/bend_arrow.png"/>
							<div>
								点击箭头指向的
								<span @click="allow" style="color: #2e8ded;">蓝色小字</span>关注我们
							</div>
							<div class="btn-allow" @click="allow">畅停天下</div>
						</div>
					</div>
				</div>
			</div>
		</cube-scroll>
	</div>
</template>

<script>
    import {mapGetters, mapMutations} from "vuex";
    import {getCode, getOpenId} from "@/api/coupon/auth";
    import {userAvailableCouponListByUserId, userUseCoupon} from "@/api/coupon/personalParkingFee";
    import fail from "@/common/img/fail.png";
    import base from "@/api/base";
    import Cookies from 'js-cookie'

    export default {
        data() {
            return {
                isSzBank: false,
                checked: true,
                checkedCoupon: undefined,
                checkedCouponId: undefined,
                checkedCouponOptions: [],
                // 进出记录
                record: "",
                // imgs: [fail],
                baseUrl: base.url + "/",
                scrollOptions: {
                    click: true,
                    bounce: false
                },
            };
        },
        computed: {
            ...mapGetters(["orderInfo", "parkinglotId", "parkrec", "parkingInfo", "doorId", "areaId", "orderSnList",
                "userOpenid", "couponFee", "keyTopOrderNo", "parkRecId", "isCardPay", "keyTopInImgUrl", "abParkId",
            ])
        },
        mounted() {
            // this.$api.parkinglot.getParkinglotInfo(this.parkrec.parkinglotId).then(res => {
            //     if (res.data.code == 200 && res.data.data) {
            if (this.parkingInfo.bankName == "苏州银行") {
                this.isSzBank = true;
                let openIdForOrder = localStorage.getItem('openIdForOrder');
                //如果本地没有openId,则让它授权
                if (this.$route.params.isEntry) {
                    console.log('isEntry');
                    if (!openIdForOrder) {
                        if (this.checkBrowser.id == 13) {//如果是微信环境就进行微信授权
                            //授权请求
                            getCode("wx").then(req => {
                                if (req.code == 200) {
                                    window.location.href = req.msg.split("http://parkinglot.scan.easthuaxin.com")[0] +
                                        "http://parkinglot.scan.easthuaxin.com/order" +
                                        req.msg.split("http://parkinglot.scan.easthuaxin.com")[1];
                                }
                            })
                        }
                    }
                } else if (this.$route.query.code) {
                    getOpenId(this.$route.query.code).then(res => {
                        if (res.code == 200) {//&& res.msg != 'null'
                            localStorage.setItem('openIdForOrder', res.msg)
                        } else {
                            alert('未获得授权');
                        }
                    })
                }
            }
            // }
            // });
            //从无牌车页面进入(orderSnList长度大于1表示是从无牌车进入的)&微信&在公众号注册过
            if (Object.keys(this.orderSnList).length > 0 && this.checkBrowser.id == "13" && localStorage.getItem('userId')) {
                this.getNoPlateUserCouponList();
            }
            this.$getAdInfo(this.abParkId)
        },
        methods: {
            ...mapMutations({
                setCouponFee: "SET_COUPONFEE",
                setOrderSnList: "SET_ORDERSNLIST"
                // setUserOpenid: "SET_USER_OPENID",
            }),
            isChecked() {
                this.checked = !this.checked;
                this.getNoPlateUserCouponList();
            },
            showImg() {
                this.$createImagePreview({
                    imgs: this.interfaceManner == 2 ? this.keyTopInImgUrl : [this.baseUrl + this.parkrec.inImgUrl]
                }).show();
            },
            getTime() {
                var _this = this;
                let yy = new Date().getFullYear();
                let mm =
                    new Date().getMonth() + 1 < 10
                        ? "0" + (new Date().getMonth() + 1)
                        : new Date().getMonth() + 1;
                let dd =
                    new Date().getDate() < 10
                        ? "0" + new Date().getDate()
                        : new Date().getDate();
                let hh =
                    new Date().getHours() < 10
                        ? "0" + new Date().getHours()
                        : new Date().getHours();
                let mf =
                    new Date().getMinutes() < 10
                        ? "0" + new Date().getMinutes()
                        : new Date().getMinutes();
                let ss =
                    new Date().getSeconds() < 10
                        ? "0" + new Date().getSeconds()
                        : new Date().getSeconds();

                return yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
            },
            getNoPlateUserCouponList() {
                if (!this.checked) {
                    this.checkedCouponId = undefined;
                    this.orderInfo.totalPrice = parseFloat(this.parkrec.unpaidMoney).toFixed(2);
                    this.setCouponFee(0.00);
                    // this.userChooseCoupon()
                } else {
                    let form = {
                        parkinglotId: this.parkinglotId,
                        inTime: this.parkrec.inTime,
                        outTime: this.parkrec.outTime,
                        userId: localStorage.getItem('userId')
                    };
                    userAvailableCouponListByUserId(form).then(res => {
                        if (res.code === 200) {
                            let checkedCouponOptions = res.data;
                            if (checkedCouponOptions.length > 0) {
                                checkedCouponOptions.map(item => {
                                    item.label = item.coupontypeName;
                                });
                                this.checkedCoupon = checkedCouponOptions[0].coupontypeName;
                                this.checkedCouponId = checkedCouponOptions[0].couponId;
                                this.userChooseCoupon()
                            } else {
                                this.checkedCoupon = undefined;
                                this.checkedCouponId = undefined;
                                // this.parkrec.unpaidMoney = parseFloat(this.orderInfo.totalPrice).toFixed(2);
                                this.setCouponFee(0.00);
                            }
                            this.checkedCouponOptions = checkedCouponOptions;
                        }
                    })
                }
            },
            userChooseCoupon() {
                let form = {
                    plateNo: this.parkrec.plateno,
                    parkinglotId: this.parkinglotId,
                    areaId: this.areaId,
                    inTime: this.parkrec.inTime,
                    couponIds: this.checkedCouponId ? [this.checkedCouponId] : [],
                    allMoney: parseFloat(this.parkrec.allmoney).toFixed(2)
                };
                userUseCoupon(form).then(res => {
                    if (res.code === 200) {
                        this.orderInfo.totalPrice = parseFloat(res.data.unpaidMoney);
                        this.setCouponFee(parseFloat(res.data.parkCoupon || 0).toFixed(2));
                    } else {
                        this.checkedCouponId = undefined;
                        this.checked = false;
                        this.orderInfo.totalPrice = parseFloat(this.parkrec.unpaidMoney).toFixed(2);
                        this.showAlert('该优惠券不可用，请重新选择');
                    }
                })
            },
            /*选择优惠券**/
            handleCouponOption() {
                this.$weui.picker(this.checkedCouponOptions, {
                    onChange: result => {
                        this.checkedCoupon = result[0].coupontypeName;
                        this.checkedCouponId = result[0].couponId;
                    },
                    onConfirm: result => {
                        this.checkedCoupon = result[0].coupontypeName;
                        this.checkedCouponId = result[0].couponId;
                    },
                    onClose: () => {
                        this.userChooseCoupon()
                    },
                    title: '可选优惠券'
                });
            },
            toPay() {
                this.$api.order
                    .payTest({
                        orderSn: this.orderSnList[this.checkedCouponId] || this.orderInfo.orderSn,
                        parkinglotId: this.parkinglotId,
                        totalAmount: parseFloat(this.orderInfo.totalPrice).toFixed(2),
                        isCoupon: this.checkedCouponId ? 1 : 0,
                        areaId: this.areaId,
                        payType: this.checkBrowser.id,
                        couponId: this.checkedCouponId ? this.checkedCouponId : undefined,
                        parkCoupon: this.checkedCouponId ? this.couponFee : undefined,
                        openId: this.isSzBank === true ? localStorage.getItem('openIdForOrder') : (this.userOpenid || localStorage.getItem('userOpenId'))
                    })
                    .then(res => {
                        console.log(res.data);
                        if (res.data.code == 200) {
                            this.$pay(res.data)
                        } else {
                            this.$createDialog({
                                type: "confirm",
                                icon: "cubeic-alert",
                                title: "提示",
                                content: res.data.msg,
                                confirmBtn: {
                                    text: "确定",
                                    active: true,
                                    disabled: false,
                                    href: "javascript:;"
                                },
                                cancelBtn: {
                                    text: "取消",
                                    active: false,
                                    disabled: false,
                                    href: "javascript:;"
                                },
                                onConfirm: () => {
                                    var parkinglotId = this.$encryptUtil.encrypt(this.parkinglotId);
                                    var doorId = this.$encryptUtil.encrypt(this.doorId);
                                    this.$router.replace({
                                        path: "/scan",
                                        query: {parkinglotId: parkinglotId, doorId: doorId}
                                    });
                                },
                                onCancel: () => {
                                }
                            }).show();
                        }
                    });
            },
            pay() {
                if (this.orderInfo.totalPrice <= 0) {
                    this.$api.parkinglot.noPay({
                        orderSn: this.orderInfo.orderSn,
                        parkCoupon: this.checkedCouponId ? this.couponFee : undefined,
                        couponId: this.checkedCouponId ? this.checkedCouponId : undefined,
                        isCoupon: this.checkedCouponId ? 1 : 0
                    }).then(res => {
                        if (res.data.code == 200) {
                            this.$createToast({
                                type: "warn",
                                time: 1000,
                                txt: "优惠券扣除成功"
                            }).show();
                            this.$router.push("PayResult");
                        }
                    });
                } else {
                    if (!this.checked) {//未选择使用优惠券
                        this.checkedCouponId = 0;
                        this.toPay()
                    } else {
                        if (Object.keys(this.orderSnList).length > 0) {//无牌车
                            if (this.checkedCouponOptions.length > 0 && !this.orderSnList[this.checkedCouponId]) {//没有使用此优惠券下过单再去下单且有优惠券

                                // if (this.parkRecId) {//暂时不考虑无牌车(科拓)
                                this.$api.order
                                    .order({
                                        outDoor: this.doorId,
                                        totalPrice: parseFloat(this.orderInfo.totalPrice).toFixed(2),
                                        parkRec: this.parkrec.id,
                                        parkinglotId: this.parkinglotId,
                                        goodsType: 2,
                                        closed: 0,
                                        paymentPlatform: this.checkBrowser.id,
                                        areaId: this.areaId,
                                        paymentPlatformsn: this.keyTopOrderNo
                                    })
                                    .then(res => {
                                        if (res.data.code == 200) {
                                            this.orderSnList[this.checkedCouponId] = res.data.data.orderSn;
                                            this.setOrderSnList(this.orderSnList);
                                            this.toPay()
                                        } else {
                                            this.$createDialog({
                                                type: "alert",
                                                title: "提示",
                                                content: "下单失败",
                                                icon: "cubeic-alert"
                                            }).show();
                                        }
                                    });
                                // } else {
                                //     let data ={
                                //         outDoor: this.doorId,
                                //         totalPrice: parseFloat(this.orderInfo.totalPrice).toFixed(2),
                                //         parkinglotId: this.parkinglotId,
                                //         goodsType: 2,
                                //         closed: 0,
                                //         paymentPlatform: this.checkBrowser.id,
                                //         areaId: this.areaId,
                                //         outTime: this.parkrec.outTime,
                                //         paymentPlatformsn: this.keyTopOrderNo
                                //     };
                                //     this.$api.parkinglot.noRecOrder(data).then(res =>{
                                //         if (res.data.code == 200) {
                                //             this.orderInfo = res.data.data;
                                //             this.setOrderInfo(that.orderInfo);
                                //             this.setOrderSnList({});
                                //             this.$router.push({name: "Order", params: {isEntry: true}});
                                //         } else {
                                //             this.showAlert(res.data.msg);
                                //         }
                                //     })
                                // }

                            } else {
                                this.toPay()
                            }
                        } else {
                            this.toPay()
                        }
                    }
                }
            },
            memberPay() {
                this.$router.push({name: 'memberOrder', params: {parkinglotId: this.parkinglotId}})
            },
            showAlert(value) {
                this.$createDialog({
                    type: "confirm",
                    icon: "cubeic-alert",
                    title: this.plateName,
                    content: value,
                    confirmBtn: {
                        text: "确定",
                        active: true,
                        disabled: false,
                        href: "javascript:;"
                    }
                }).show();
            },
            // 获取10位时间戳
            timest() {
                var tmp = Date.parse(new Date()).toString();
                tmp = tmp.substr(0, 10);
                return tmp;
            },
            back() {
                this.$router.go(-1);
            },
            // 关注公众号
            allow() {
                window.location.href =
                    "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzU1MjE3NTEzNw==&scene=124#wechat_redirect";
            }
        },
        components: {}
    };
</script>

<style lang="stylus" scoped>
	@import '~common/stylus/variable';
	@import '~common/stylus/mixin';

	.single-page-wrap {
		.cube-scroll {
			position: relative;
			text-align: left;
			white-space: normal;
			max-height: 100%
			/*overflow hidden*/
			/*background: #ffffff;*/
			margin-bottom 50px
			/*.advwrap{*/
			/*width 100%*/
			/*height 0*/
			/*padding-bottom 30%*/
			//}
			.weui-article .weui-cell__bd {
				color #0d0d0d
				line-height 40px
				font-size 15px
			}
			.header {
				color #0d0d0d
				width: 100%;
				height: 45px;
				display: flex;
				flex-direction: row;
				align-items: center;
				background: #ffffff;
				position: relative;
				justify-content: center;
				border-bottom: 1px solid #f5f5f5;

				i {
					position: absolute;
					left: 10px;
					font-size: 18px;
					padding: 6px;
				}
			}

			.order-panel {
				width: 90%;
				display: flex;
				flex-direction: column;
				background: #ffffff;
				border-radius: 5px;
				padding-left: 16px;
				padding-right: 16px;
				box-sizing: border-box;
				margin: auto;

				.order-record {
					display: flex;
					flex-direction: column;
					align-items: center;

					.park-name {
						font-size: 22px;
						font-weight: 500;
					}

					.plate {
						display: flex;
						align-items: center;
						font-size: 18px;
						color: #666;
						padding: 15px 0 15px 0;

						.check-pic {
							font-size: 14px;
							color: #A1A8AA;
							padding: 5px 15px;
							border: 1px solid rgba(161, 168, 170, 0.6);
							margin-left: 10px;
						}
					}

					.in-time {
						font-size: 15px;
						color: #666;
					}
				}

				.discount-panel {
					width: 100%;
					border-bottom 1px solid #f5f5f5
					display: flex;
					flex-direction: column;
					padding 20px 0 10px 0;
					.weui-article {
						padding 0
						section {
							margin-bottom 0 !important
							.weui-cell_select-after {
								padding-left 0
							}
						}
					}
					.div_check {
						width: 100%;
						height: 35px;
						display: flex;
						flex-direction: row;
						align-items: center;
						/*margin-bottom: 8px;*/
						font-size: 15px;

						.div_left {
							height: 16px;
							width: 16px;
							border: 1px solid #dddddd;
							margin-right: 8px;

							img {
								width: 100%;
								height: 100%;
								display: none;
							}
						}

						.check {
							border: 0px;

							img {
								display: block;
							}
						}

						.div_right {
							color #0d0d0d
							font-size: 16px;
						}
					}
				}

				.order-info {
					padding-top: 10px;
					width: 100%;
					display: flex;
					flex-direction: column;
					box-sizing: border-box;

					.price-wrap {
						color #0d0d0d
						display: flex;
						font-size: 20px;
						font-weight: 500;
						padding: 10px 0;

						.price {
							font-size: 18px;
							font-weight: 600;
							color: #EB3120;
							padding-left: 10px;
						}
					}

					.order-item {
						width: 100%;
						height: 30px;
						display: flex;
						flex-direction: row;
						align-items: center;
						justify-content: space-between;
						font-size: 14px;
						color: #B0B0B0;
					}
				}
			}

			.btn-pay {
				width: 90%;
				height: 45px;
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;
				font-size: 16px;
				color: #ffffff;
				background: #5495f6;
				border-radius: 5px;
				margin: 24px auto 0 auto;
			}
			.btn-member {
				background-color $color-estate
			}

			.hint-wrapper {
				width: 100%;
				height: 170px;
				display: flex;
				flex-direction: column;
				align-items: center;

				.hint-panel {
					width: 90%;
					height: 80px;
					display: flex;
					flex-direction: column;
					margin-top: 10px;
					position: relative;
				}

				.hint-item {
					width: 100%;
					height: 30px;
					display: flex;
					flex-direction: row;
					align-items: center;
					font-size: 14px;
					color: #999999;
				}

				.hint-bottom {
					position: absolute;
					right: 70px;
					bottom: 0;
					display: flex;
					flex-direction: row;
					align-items: baseline;
					font-size: 14px;

					img {
						width: 80px;
						position: absolute;
						right: -48px;
						top: -30px;
					}
					.btn-allow {
						color: #2e8ded;
						position: absolute;
						bottom: -55px;
						right: -85px;
						font-size: 17px;
						padding: 12px;
						letter-spacing: 2px;
					}
				}
			}
		}

	}
</style>
